import { useIntl } from 'react-intl'

import { DEFAULT_LOCALE } from 'i18n'

export function useLocale() {
  const { locale } = useIntl()
  return locale ?? DEFAULT_LOCALE
}
